import React from "react";

import { IconMainMenuStackpacks } from "~/components/icon";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { STACKPACKS_PATH } from "../../stackPacks/StackPacksRoute";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const StackPacksIndexBreadcrumb = () => {
	const link = useNavigateToLink(STACKPACKS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<BreadcrumbLayout
			icon={<IconMainMenuStackpacks className={BREADCRUMB_ICON_CLASS} />}
			label="StackPacks"
			to={link}
		/>
	);
};

StackPacksIndexBreadcrumb.PATH = STACKPACKS_PATH;
